import React from 'react';
import { usePortfolio } from './../Context/PortfolioContext'; // Adjust the path as needed
import YearlyPriceChart from './VisualizationComponent/YearlyPriceChart/YearlyPriceChart';
import OptimizationResultsPieChart from './VisualizationComponent/PiChart/PiChart';
import PortfolioMetricsCard from './PortfolioMetricsCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faBalanceScale, faSeedling, faDollarSign } from '@fortawesome/free-solid-svg-icons';
const MonteCarloResultsVisualization = ({ }) => {
    const { portfolioData } = usePortfolio();
    const { optimizationMethod, optimizationResults, selectedAssets } = portfolioData;
    // Assuming data.optimizedWeights is an array of weights
    if (!optimizationResults || !optimizationResults.optimizedWeights) {
        return <p>No Monte Carlo simulation results to display.</p>;
    }
    console.log("The method which we used to perform the optimization is ", optimizationMethod);
    console.log("The data for pre visualization is", selectedAssets);
    console.log("The weight for the pre visualization is ", optimizationResults)
    return (
        <></>
    );
};

export default MonteCarloResultsVisualization;

